import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RunwayService } from '../service/runway.service';
import { EditTakeoffLandAreaComponent } from '../edit-takeoff-land-area/edit-takeoff-land-area.component';

@Component({
  selector: 'app-delete-takeoff-land-area',
  templateUrl: './delete-takeoff-land-area.component.html',
  styleUrls: ['./delete-takeoff-land-area.component.scss']
})
export class DeleteTakeoffLandAreaComponent implements OnInit {
  takeoffLandAreaId: number;
  airportId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditTakeoffLandAreaComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _runwayService: RunwayService) {
    this.takeoffLandAreaId = data.takeoffLandAreaId;
    this.airportId = data.airportId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._runwayService.deleteTakeoffLandArea(this.airportId, this.takeoffLandAreaId);
      this.isLoading = false;
      this.close({success: true, takeoffLandAreaId: this.takeoffLandAreaId});
    } catch (e) {
      this.close({success: false, error: e});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
